import axios from "axios";

export default {
  async findAll() {
    return axios.get(`/commissions`);
  },
  async update(formData) {
    return axios.put(`/commissions/${formData.id}`, formData);
  }
};
